import { create } from "zustand";

/** Canais da aba Saída (como os "Output channels" do VS Code). */
export const OUTPUT_SOURCES = [
  "Sincronização",
  "Cópia local",
  "Terminal",
  "Executar",
  "Git",
  "Copilot",
  "Claude",
  "Extensões",
] as const;
export type OutputSource = (typeof OUTPUT_SOURCES)[number];
export type OutputLevel = "info" | "warn" | "error";

export interface OutputEntry {
  id: number;
  at: number;
  source: OutputSource;
  level: OutputLevel;
  text: string;
}

const MAX_ENTRIES = 1_000;
let seq = 0;

/**
 * Registro do que o app fez nesta sessão: conexão com o time, terminais, disco do sandbox, Git e
 * IA. Só eventos reais, nada do conteúdo do terminal (que é só de quem o abriu).
 */
export const useOutput = create<{
  entries: OutputEntry[];
  /** Erros desde a última vez que a aba Saída ficou visível. */
  unseenErrors: number;
  clear(): void;
  markSeen(): void;
}>((set) => ({
  entries: [],
  unseenErrors: 0,
  clear: () => set({ entries: [], unseenErrors: 0 }),
  markSeen: () => set({ unseenErrors: 0 }),
}));

const REPEAT_MS = 2_000;

export function logOutput(source: OutputSource, text: string, level: OutputLevel = "info") {
  const now = Date.now();
  const last = useOutput.getState().entries.at(-1);
  if (last && last.source === source && last.text === text && now - last.at < REPEAT_MS) return;
  const entry: OutputEntry = { id: ++seq, at: now, source, level, text };
  useOutput.setState((s) => ({
    entries:
      s.entries.length >= MAX_ENTRIES ? [...s.entries.slice(-MAX_ENTRIES + 1), entry] : [...s.entries, entry],
    unseenErrors: level === "error" ? s.unseenErrors + 1 : s.unseenErrors,
  }));
}
